import React from 'react';
import * as Icon from 'react-feather';
import {useAppDispatch} from '../../hooks/redux';

import {
    Button as AlchemyButton,
    Tooltip as AlchemyTooltip,
} from '@amzn/alchemy-components-react'

import { removeBookmarkCard } from '../../slices/bookmarkCardsSlice';
import { addMessage } from '../../slices/messageQueueSlice';
import { BookmarksApiService } from '../../api';
import i18n from '../../i18n';

interface Bookmark {
    entity: string;
    title: string;
    description?: string;
    isExample?: boolean;
    [key: string]: any; // For any additional properties
}

interface RemoveBookmarkButtonProps {
    bookmark: Bookmark;
    size?: "sm" | "md" | "lg";
    iconSize?: string;
}

export default function(props: RemoveBookmarkButtonProps) {
    const dispatch = useAppDispatch()
    const data = props.bookmark
    const size = props.size || "sm"
    const iconSize = props.iconSize || "16"
    const bmkApi = new BookmarksApiService()

    const handleRemoveBookmark = (bookmark: Bookmark) => {
        async function removeBookmark(bookmarkId: string) {
            try {
                await bmkApi.removeBookmark(bookmarkId)
                // Use the bookmark entity ID directly to ensure it matches what's in the state
                dispatch(removeBookmarkCard(bookmarkId))
                // dispatch message
                dispatch(addMessage({
                    id: Date.now().toString(),
                    icon: "remove",
                    title: i18n.t('bookmark-removed'),
                    text: bookmark.title,
                    duration: 5000
                }))
            } catch (error) {
                console.error('Failed to remove bookmark:', error)
                // Show error message
                dispatch(addMessage({
                    id: Date.now().toString(),
                    icon: "alert-triangle",
                    title: i18n.t('bookmark-remove-failed'),
                    text: bookmark.title,
                    duration: 5000
                }))
            }
        }
        removeBookmark(bookmark.entity)
    }

    return (
        <AlchemyTooltip position="top">
            <span slot="trigger">
                <AlchemyButton
                    size={size}
                    disabled={data.isExample}
                    onClick={() => handleRemoveBookmark(data)}
                >
                    <Icon.Slash size={iconSize} />
                </AlchemyButton>
            </span>
            <p className='mb-0'>{data.isExample ? i18n.t('button:prevent-del-example-bookmark') : i18n.t('remove-bookmark')}</p>
        </AlchemyTooltip>
    )
}
